import { useEffect, useState } from "react";
import { useOrders } from "#orders-context.tsx";
import { formatTime } from "#orders.ts";
import { OrderDialog } from "#order-dialog.tsx";

/** A readable counter display with ready and preparing pickup names. */
export function CustomerDisplay() {
  const { orders, connection } = useOrders();
  const [selected, setSelected] = useState<string>();
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 15_000);
    return () => clearInterval(timer);
  }, []);
  const active = orders.filter(
    (order) => order.active && !order.isScheduled(now),
  );
  const selectedOrder = orders.find((order) => order.id === selected);
  return (
    <div className="customer-display">
      <img
        className="brand-logo large"
        src="/title-icon.png"
        alt="Pocket Rice"
      />
      <p className="eyebrow">Freshly made for you</p>
      <h1>Your order</h1>
      {connection !== "live" && (
        <p role="status">Connecting to live updates…</p>
      )}
      <div className="pickup-columns">
        {(["ready", "preparing"] as const).map((group) => (
          <section className="settings-card" key={group}>
            <h2>{group === "ready" ? "Ready to collect" : "Preparing"}</h2>
            {active
              .filter(
                (order) =>
                  (order.state === "order_ready") === (group === "ready"),
              )
              .map((order) => (
                <button
                  className="pickup-tile"
                  key={order.id}
                  onClick={() => setSelected(order.id)}
                >
                  <strong>{order.label}</strong>
                  <span>{formatTime(order.createdAt)}</span>
                </button>
              ))}
          </section>
        ))}
      </div>
      <p className="muted">Tap an order to display its customer tracking QR.</p>
      {selectedOrder && (
        <OrderDialog
          mode="display"
          order={selectedOrder}
          close={() => setSelected(undefined)}
        />
      )}
    </div>
  );
}
